module.exports = __webpack_public_path__ + "static/rcc-knb61-study-characteristics-desktop-59a62eba49c2af5de4683097fc97af38.png";